import { useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import type { CRMEntity } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

import ExportToDynamicsDropdownItem from "../../components/ExportToDynamicsDropdownItem/ExportToDynamicsDropdownItem";
import {
    selectIsDynamicsCompanyAsLeadExportClaimEnabled,
    selectDynamicsIsNotIntegrated,
    selectDynamicsContactsToggleState,
    selectDynamicsLeadsToggleState,
} from "../../store/selectors/dynamicsSelectors";

type ContactsDynamicsExportItemContainerProps = {
    onClick(destination: string, as?: CRMEntity): void;
    tooltipDisabledContent?: string;
    isUseLockedIcon?: boolean;
    isExportDisabled?: boolean;
};

const ContactsDynamicsExportItemContainer = ({
    onClick,
    tooltipDisabledContent,
    isUseLockedIcon,
    isExportDisabled,
}: ContactsDynamicsExportItemContainerProps) => {
    const isDynamicsNotIntegrated = useSelector(selectDynamicsIsNotIntegrated);
    const isDynamicsContactsExportEnabled = useSelector(selectDynamicsContactsToggleState);
    const isDynamicsLeadsExportEnabled = useSelector(selectDynamicsLeadsToggleState);
    const isCompanyAsLeadExportClaimEnabled = useSelector(selectIsDynamicsCompanyAsLeadExportClaimEnabled);

    const enabledEntity: CRMEntity = isDynamicsContactsExportEnabled ? "contact" : "lead";

    if (isDynamicsNotIntegrated) {
        return null;
    }

    if (tooltipDisabledContent || isExportDisabled) {
        return (
            <ExportToDynamicsDropdownItem
                isDisabled
                isUseLockedIcon={isUseLockedIcon}
                text={translate("si.contacts_search.action.export.variant.dynamics.text")}
                tooltipDisabledContent={tooltipDisabledContent}
            />
        );
    }

    if (
        (!isDynamicsContactsExportEnabled && !isDynamicsLeadsExportEnabled) ||
        (isCompanyAsLeadExportClaimEnabled && !isDynamicsContactsExportEnabled)
    ) {
        return (
            <ExportToDynamicsDropdownItem
                isDisabled
                isUseLockedIcon={isUseLockedIcon}
                text={translate("si.contacts_search.action.export.variant.dynamics.text")}
                tooltipDisabledContent={translate("si.contacts_search.action.variant.export_to_crm.disabled")}
            />
        );
    }

    if (isDynamicsContactsExportEnabled && isDynamicsLeadsExportEnabled && !isCompanyAsLeadExportClaimEnabled) {
        return (
            <>
                <ExportToDynamicsDropdownItem
                    text={`${translate("si.contacts_search.action.export.variant.dynamics.text")}:`}
                />
                <ExportVariantsDropdownItem
                    variant="contacts"
                    text={translate("si.contacts_search.action.export.variant.contacts.text")}
                    onClick={() => onClick("dynamics", "contact")}
                />
                <ExportVariantsDropdownItem
                    variant="leads"
                    text={translate("si.contacts_search.action.export.variant.leads.text")}
                    onClick={() => onClick("dynamics", "lead")}
                />
            </>
        );
    }

    return (
        <ExportToDynamicsDropdownItem
            text={translate("si.contacts_search.action.export.variant.dynamics.text")}
            onClick={() => onClick("dynamics", enabledEntity)}
        />
    );
};

export default ContactsDynamicsExportItemContainer;
